import { Component, input } from '@angular/core';

@Component({
  selector: 'app-search',
  imports: [],
  templateUrl: './search.html',
})
export class Search {
  size = input("6");
}

